import { defineStore } from 'pinia'

import type { CommonStore } from './interfaces'

import { PageType } from '@ts-tutor-landing/enums'

import { actions } from './actions'
import { getters } from './getters'

export const useCommonStore = defineStore('common', {
  state: (): CommonStore => ({
    loading: false,
    pageType: PageType.Math,
    modalTutorApplication: false,
    modalTutorApplicationSuccess: false,
  }),
  actions,
  getters,
})
